import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=297f603f&"
var script = {}
import style0 from "./CloseButton.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports